export const LogCategory = {
    BUILD_BINDING: 'Field.Binding',
    CITYSELECTOR_DATASOURCE: 'CitySelector.DataSource',
    DEPARTMENT_SELECTOR_DATASOURCE: 'DepartmentSelector.DataSource',
    COUNTRY_SELECTOR_DATASOURCE: 'CountrySelector.DataSource',
    COMBOBOX_DATASOURCE: 'ComboBox.DataSource',
    COMBOBOX_RENDER: 'ComboBox.Render',
    DATATABLE_DATASOURCE: 'DataTable.DataSource',
    DATATABLE_RENDER: 'DataTable.Render',
    FIELD_DATASOURCE: 'Field.DataSource',
    FIELD_VALUE_UPDATE: 'Field.Value',
    FORM_LOAD: 'Form.Load',
    FORM_SAVED: 'Form.Save',
    FORM_SAVING: 'Form.Saving',
    FORM_VALUES_UPDATE: 'Form.Value',
    SEARCHABLECOMBOBOX_DATASOURCE: 'SearchableComboBox.DataSource',
    SEARCHABLECOMBOBOX_RENDER: 'SearchableComboBox.Render',
    SECTIONSELECTOR_DATASOURCE: 'SelectionSelector.DataSource',
    SUBSCRIBE_FORM_EVENT: 'Form.Event',
    USERSELECTOR_DATASOURCE: 'UserSelector.DataSource',
    DOWNLOAD_PARAMETRIC_ENTITY_ITEMS: 'Entity.DataSource',
}